import React, { Component } from "react";
import { withNamespaces } from "react-i18next";
import { Icon } from "@iconify/react";

import Button from "../../components/Button/Button";
// import StringInput from "../../components/Input/StringInput/StringInput";
import NumberInput from "../../components/Input/NumberInput/NumberInput";
import MobileSelectRadio from "../../components/MobileAssets/MobileSelectRadio/MobileSelectRadio";
import SecurityPinModal from "../../components/SecurityPinModal/SecurityPinModal";

class MobileQuotaDeposit extends Component 
{
    constructor(props) 
    {
        super(props);
        this.state = 
        {
            showSelectRadio: false,
            showAddSecurityPin: true,
        }
    }

    toggleSelectRadio = () => 
    {
        this.setState({
            showSelectRadio: !this.state.showSelectRadio,
        });
    }

    toggleShowAddSecurityPin = () => 
    {
        this.setState({
            showAddSecurityPin: !this.state.showAddSecurityPin
        });

        this.props.securityPinModalHandler("enter-sec-pin");
    }

    imageImport = (r) => 
    {
        let images = {};
        r.keys().map((item, index) => 
        {
            return (images[item.replace("./", "")] = r(item)["default"]);
        });
        return images;
    }

    render() 
    {
        const { t } = this.props;
        const icons = this.imageImport(require.context("../../assets/images/icons", false, /\.(png|jpe?g|svg)$/));
        const img = this.imageImport(require.context("../../assets/images/loginregister/", false, /\.(png|jpe?g|svg|webp)$/));
        const num_format = { maximumFractionDigits: 2, minimumFractionDigits: 2 };

        return (
            <>
            <SecurityPinModal
                {...this.props}
                {...this.state}
                closeAddSecurityPin={this.props.toggleSecurityPinModal}
                showAddSecurityPin={this.props.openSecurityPinModal}
                securityPin={this.props.securityPinModal}
            />

            <div className="quota-deposit-container">
                <div className="available-amount-content mb-3">
                    <img src={icons["wallet-icon.svg"]} alt="wallet" />
                    <div className="amount-body">
                        <p className="mb-2">{t('delegate-deposit.available-quota')}</p>
                        <div className="amount">
                            <p>
                                {/* {this.props.showQuota ? this.props.quotaAmount : this.props.encryptQuotaAmount} */}

                                {this.props.showQuota 
                                ? 
                                new Intl.NumberFormat("en-US", num_format).format(this.props.balance) 
                                : 
                                    '*******'
                                }
                            </p>
                            <img
                                className="show-hide-btn"
                                src={img[`${(!this.props.showQuota) ? 'close-' : ''}eye.png`]}
                                alt="hide pwd"
                                id="showQuota"
                                name="showQuota"
                                onClick={(event) => this.props.onInputChangeHandler(event)}
                            />
                        </div>
                    </div>
                </div>

                {/* <form className="forms-col needs-validation"> */}
                <form className="forms-col needs-validation" method="post" id="form" encType="multipart/form-data" onSubmit={this.props.submitHandler} noValidate>
                    <div className="pd-form-m-col">
                        <div>
                            <label>
                                <span className="text-danger">*</span> {t('delegate-deposit.member')}
                            </label>
                            <div className="input-group-col">
                                <div className="input-group right has-validation">
                                    {/* <StringInput
                                        id='member_id'
                                        name='member_id'
                                        placeholder='Insert Member Username'
                                        className={`form-control p-0 ${this.props.errorMsg.member_id && "was-validated is-invalid"}`}
                                        value={this.props.member_id || ''}
                                        onChange={(event) => this.props.onInputChangeHandler(event)}
                                        required={true}
                                        requiredMessage={t("validation.required")}
                                        errorMsg={this.props.errorMsg.member_id || ""}
                                        formError={this.props.formError}
                                    /> */}
                                    {/* <div className="input-group right">
                                        <p className="form-control lh-lg" onClick={this.toggleSelectRadio}>
                                            {this.props.mobileOpts ? this.props.mobileOpts.label : <>Select Member</>}
                                        </p>
                                        {this.props.mobileOpts && (
                                            <span className="input-group-text">
                                                <Icon icon="mdi:close-circle" onClick={this.props.memberChangeHandler} />
                                            </span>
                                        )}
                                        <span className="input-group-text" onClick={this.toggleSelectRadio}>
                                            <Icon icon="uil:angle-right" />
                                        </span>
                                    </div> */}

                                    <div className="input-group right">
                                        <p className={`form-control lh-lg ${(this.props.errorMsg.member_id) ? 'is-invalid' : ''}`} onClick={this.toggleSelectRadio}>
                                            {this.props.mobileOpts ? this.props.mobileOpts.label : <>{t('delegate-deposit.select-member')}</>}
                                        </p>
                                        {this.props.mobileOpts && (
                                            <span className="input-group-text">
                                                <Icon icon="mdi:close-circle" onClick={this.props.memberChangeHandler} />
                                            </span>
                                        )}
                                        <span className="input-group-text" onClick={this.toggleSelectRadio}>
                                            <Icon icon="uil:angle-right" />
                                        </span>
                                        <div className="invalid-feedback">{this.props.formError && this.props.errorMsg.member_id}</div>
                                    </div>
                                    
                                    <div className="invalid-feedback">{this.props.formError && this.props.errorMsg.member_id}</div>
                                    <MobileSelectRadio
                                        name={"member_id"}
                                        toggleHandler={this.toggleSelectRadio}
                                        showSelectRadio={this.state.showSelectRadio}
                                        onChange={this.props.memberChangeHandler}
                                        options={this.props.downlineList}
                                        value={this.props.mobileOpts && this.props.mobileOpts.key !== null ? this.props.mobileOpts.key : null}
                                    />
                                </div>
                                <hr className="my-0" />
                            </div>
                        </div>

                        <div>
                            <label>
                                <span className="text-danger">*</span> {t('delegate-deposit.amount')}
                            </label>
                            <div className="input-group-col">
                                <div className="input-group right has-validation">
                                    {/* <input
                                        className="form-control p-0"
                                        type="number"
                                        placeholder="Insert Deposit Amount"
                                        onChange={(e) => this.props.insertDepositAmount(e)}
                                    /> */}
                                    <NumberInput
                                        id="amount"
                                        name="amount"
                                        className={`form-control p-0 ${this.props.errorMsg.amount && "was-validated is-invalid"}`}
                                        aria-label="Amount"
                                        aria-describedby="depositAmtHelp"
                                        value={this.props.amount}
                                        placeholder={`${t("deposit.min-max-limit")} ${new Intl.NumberFormat("en-US", num_format).format(
                                            (this.props.setting.transaction_minimum_payment_amount) ? this.props.setting.transaction_minimum_payment_amount : 0.0
                                        )}/${new Intl.NumberFormat("en-US", num_format).format(
                                            (this.props.setting.transaction_maximum_payment_amount) ? this.props.setting.transaction_maximum_payment_amount : 0.0
                                        )}`}
                                        onChange={(event) => this.props.onInputChangeHandler(event)}
                                        required={true}
                                        step="any"
                                        onKeyPress={(evt) => (evt.key === "e" || evt.key === "-" || evt.key === "+") && evt.preventDefault()}
                                        requiredMessage={t("validation.required")}
                                        formError={this.props.formError}
                                        errorMsg={this.props.errorMsg.amount || ""}
                                    />
                                </div>
                                <hr className="my-0" />
                            </div>
                        </div>

                    </div>
                    {/* <button type="submit" className="btn btn-gradient-blue mx-3" disabled>
                        Submit
                    </button> */}
                    <Button
                        typeButton={`submit`}
                        classValue="btn btn-gradient-blue mx-3"
                        buttonName={t('global.submit')}
                        clicked={null}
                    />
                </form>
            </div>
            </>
        );
    }
}

export default withNamespaces("translation")(MobileQuotaDeposit);